// extracted by mini-css-extract-plugin
export default {"loginForm":"loginForm_loginForm__dvagM","extraWrapper":"loginForm_extraWrapper__H8tHE"};